export default {
  'site.name': 'AllChinaBuy Spreadsheet',
  'site.tagline': 'Votre Façon Plus Intelligente d\'Explorer AllChinaBuy',
  'site.description': 'Explorez la feuille de calcul AllChinaBuy avec des listes de produits, des guides de vendeurs, des conseils QC, des informations d\'expédition, des avis et des ressources d\'achat.',
  'nav.home': 'Accueil',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Guides',
  'nav.products': 'Produits',
  'nav.sellers': 'Vendeurs',
  'nav.shipping': 'Expédition',
  'nav.qc': 'QC',
  'nav.review': 'Avis',
  'nav.safety': 'Sécurité',
  'nav.articles': 'Articles',
  'nav.language': 'Langue',
  'nav.mainSite': 'Site Principal',
  'nav.shoppingGuide': 'Guide d\'Achat',
  'hero.title': 'AllChinaBuy Spreadsheet : Trouvez des Produits, Vendeurs & Guides d\'Achat',
  'hero.subtitle': 'Découvrez des ressources organisées AllChinaBuy, des guides de produits, des informations sur les vendeurs, des conseils QC, des guides d\'expédition et des conseils d\'achat pratiques en un seul endroit.',
  'hero.cta.explore': 'Explorer AllChinaBuy Spreadsheet',
  'hero.cta.guides': 'Parcourir les Guides d\'Achat',
  'hero.cta.mainSite': 'Visiter le Site Principal',
  'hero.search.placeholder': 'Rechercher spreadsheet, produits, vendeurs ou guides...',
  'categories.title': 'Catégories Populaires',
  'categories.subtitle': 'Parcourez nos catégories de produits sélectionnées du spreadsheet AllChinaBuy',
  'categories.all': 'Toutes les Catégories',
  'features.title': 'Pourquoi Utiliser AllChinaBuy Spreadsheet',
  'features.organized': 'Produits Organisés',
  'features.organized.desc': 'Tous les produits soigneusement catégorisés et consultables pour une découverte facile.',
  'features.sellers': 'Vendeurs Vérifiés',
  'features.sellers.desc': 'Trouvez des vendeurs fiables avec des évaluations et des informations sur la qualité des produits.',
  'features.qc': 'Conseils QC',
  'features.qc.desc': 'Apprenez les astuces de contrôle qualité pour vous assurer de recevoir exactement ce que vous avez commandé.',
  'features.shipping': 'Infos d\'Expédition',
  'features.shipping.desc': 'Comparez les méthodes d\'expédition, les coûts et les délais de livraison vers votre pays.',
  'articles.title': 'Derniers Guides & Articles',
  'articles.subtitle': 'Ressources approfondies pour vous aider à acheter plus intelligemment sur AllChinaBuy',
  'articles.readMore': 'Lire la Suite',
  'articles.allArticles': 'Voir Tous les Articles',
  'products.title': 'Produits en Vedette',
  'products.subtitle': 'Parcourez les produits sélectionnés du spreadsheet AllChinaBuy. Cliquez sur un article pour accéder à la page produit et finaliser votre achat.',
  'products.viewAll': 'Voir Tout',
  'products.buy': 'Acheter',
  'products.viewFull': 'Voir le Spreadsheet Complet',
  'products.wantMore': 'Vous voulez voir plus de produits ?',
  'products.moreDesc': 'Explorez le spreadsheet AllChinaBuy complet avec plus de 10 000 produits vérifiés dans toutes les catégories.',
  'products.visitFull': 'Visiter le Spreadsheet Complet',
  'cta.title': 'Prêt à Commencer vos Achats ?',
  'cta.subtitle': 'Visitez notre site principal pour parcourir le spreadsheet AllChinaBuy complet et commencer votre voyage d\'achat.',
  'cta.button.main': 'AllChinaBuy Spreadsheet',
  'cta.button.buy': 'Acheter Maintenant',
  'footer.about': 'À Propos',
  'footer.contact': 'Contact',
  'footer.privacy': 'Politique de Confidentialité',
  'footer.terms': 'Conditions d\'Utilisation',
  'footer.disclaimer': 'Avertissement',
  'footer.editorial': 'Politique Éditoriale',
  'footer.copyright': 'AllChinaBuy Spreadsheet. Hub de ressources indépendant. Non affilié à AllChinaBuy.',
  'footer.disclaimerText': 'Ce site web est une ressource d\'information indépendante et n\'est pas affilié ou officiellement approuvé par AllChinaBuy, sauf mention explicite.',
  'lang.en': 'Anglais',
  'lang.fr': 'Français',
  'lang.da': 'Danois',
  'lang.de': 'Allemand',
  'seo.homeTitle': 'AllChinaBuy Spreadsheet – Produits, Vendeurs & Guides d\'Achat',
  'seo.homeDescription': 'Explorez la feuille de calcul AllChinaBuy avec des listes de produits, des guides de vendeurs, des conseils QC, des informations d\'expédition, des avis et des ressources d\'achat.',
};